import React from 'react';
import { Formik, FormikValues } from 'formik';
import styled from 'styled-components';
// Material UI
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';

import { REPORT_LISTING_OPTIONS } from 'src/utils/constants';
import { ReportListingSchema } from 'src/utils/validationSchemas';
import TextField from '../formik/input/TextField';

const Form = styled.form`
  width: 80%;
  display: flex;
  justify-content: center;
  .MuiFormControl-root {
    width: 100%;
  }
`;
const TextArea = styled(TextField)``;

export interface IReportListingFormikValues {
  details: string;
  option: string;
}

interface IProps {
  handleReportSubmit: (values: IReportListingFormikValues | FormikValues) => void;
}

const ReportListingForm = ({ handleReportSubmit }: IProps) => {
  return (
    <Formik
      onSubmit={async (values: IReportListingFormikValues, formikHelpers) => {
        formikHelpers.setSubmitting(true);
        await handleReportSubmit(values);
        formikHelpers.setSubmitting(false);
      }}
      initialValues={{
        details: '',
        option: '',
      }}
      validationSchema={ReportListingSchema}
    >
      {(formikProps) => {
        const {
          values,
          errors,
          touched,
          setFieldTouched,
          setFieldValue,
          handleSubmit,
          isSubmitting,
        } = formikProps;
        return (
          <Form onSubmit={handleSubmit}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="reportListing"
                name="option"
                value={values.option}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('option', (event.target as HTMLInputElement).value);
                }}
              >
                {REPORT_LISTING_OPTIONS.map((option, index) => {
                  return (
                    <FormControlLabel
                      key={index}
                      value={option.id}
                      control={<Radio />}
                      label={option.name}
                    />
                  );
                })}
                <FormHelperText error style={{ marginBottom: 10 }}>
                  {errors && touched.option && errors.option}
                </FormHelperText>
              </RadioGroup>
              <TextArea
                value={values.details}
                onChangeHandler={(val) => {
                  setFieldValue('details', val);
                }}
                onBlurHandler={() => setFieldTouched('details', true)}
                placeholder="Enter Details here"
                name="details"
                outlined
                error={errors && errors.details && touched.details}
                multiline
                rows={5}
              />
              <FormHelperText error style={{ marginBottom: 10 }}>
                {errors && touched.details && errors.details}
              </FormHelperText>
              <Button
                disabled={isSubmitting}
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: 20 }}
              >
                Submit
              </Button>
            </FormControl>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReportListingForm;
